import { render, staticRenderFns } from "./ZhiqiTongCopy.vue?vue&type=template&id=83b92e2e&scoped=true"
import script from "./ZhiqiTongCopy.vue?vue&type=script&lang=js"
export * from "./ZhiqiTongCopy.vue?vue&type=script&lang=js"
import style0 from "./ZhiqiTongCopy.vue?vue&type=style&index=0&id=83b92e2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b92e2e",
  null
  
)

export default component.exports